import { render, staticRenderFns } from "./PortfolioCreatorCalculator.vue?vue&type=template&id=00a43f2e&scoped=true&"
import script from "./PortfolioCreatorCalculator.vue?vue&type=script&lang=js&"
export * from "./PortfolioCreatorCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCreatorCalculator.vue?vue&type=style&index=0&id=00a43f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a43f2e",
  null
  
)

export default component.exports